/**
 * Calendar OAuth: exchange auth code for tokens (store refresh on backend) and get stored access token.
 * Used so calendar access is stored and reused without re-prompting.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';

const functions = getFunctions(app, 'us-central1');

/**
 * Exchange OAuth authorization code for tokens; backend stores refresh token.
 * @param {{ code: string, redirectUri: string }} params
 * @returns {Promise<{ accessToken: string }>}
 */
export async function exchangeCalendarAuthCode({ code, redirectUri }) {
  const fn = httpsCallable(functions, 'calendarExchangeAuthCode');
  const res = await fn({ code, redirectUri });
  return res.data;
}

/**
 * Get a fresh access token using stored refresh token (no user interaction).
 * @returns {Promise<{ accessToken: string }>}
 * @throws when no refresh token is stored or it is invalid (use requestCalendarAccess popup then).
 */
export async function getCalendarAccessToken() {
  const fn = httpsCallable(functions, 'calendarGetAccessToken');
  const res = await fn({});
  return res.data;
}
